import { FC } from "react";
import { SessionItem, SessionRenderingContext } from "@/mds/components/sessions/session-item";
import { MDSSessionPart } from "@/mds/components/sessions/session-parts/session-part";
import { first } from "lodash-es";

interface Props {
  item: SessionItem;
  context: SessionRenderingContext;
}

export const StandardSessionItemRenderer: FC<Props> = ({ item, context }) => {
  const firstSessionItemData = first(item.data);

  if (!firstSessionItemData) {
    return null;
  }

  /**
   * @MacroMackie - TODO - clean this up in a future PR.
   */
  const partContext = {
    ...firstSessionItemData.context,
    itemId: item.id,
    lastArtifactId: context.lastArtifactId,
  };

  const partConfig = context.config;

  return (
    <MDSSessionPart part={firstSessionItemData.part} context={partContext} config={partConfig} />
  );
};
